import { Link } from "@/components/common/Link";
import { useState, useEffect, useRef } from "react";
export default function HeroSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section className="acad-home-hero" style={{
    backgroundColor: "#F5F4F2",
    width: "100%",
    height: "clamp(620px, 74svh, 720px)",
    minHeight: "620px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    position: "relative",
    zIndex: 10,
    overflow: "hidden"
  }}>
      <style>{`
        @import url('https://api.fontshare.com/v2/css?f[]=switzer@400,500,600,700&display=swap');
        
        .hero-learn-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background-color: #353533;
          color: #ffffff;
          border-radius: 28px;
          border: 0 !important;
          outline: 0;
          box-shadow: none !important;
          padding: 6px 6px 6px 16px;
          text-transform: uppercase;
          font-family: 'Switzer', sans-serif;
          font-size: 14px;
          font-weight: 500;
          line-height: 21px;
          text-decoration: none;
          cursor: pointer;
          transition: opacity 0.15s ease;
        }
        
        .hero-learn-more-btn:hover {
          opacity: 0.9;
        }

        .hero-learn-more-btn:focus-visible {
          outline: 3px solid rgba(1, 139, 185, 0.45);
          outline-offset: 3px;
        }

        .hero-learn-more-btn .arrow-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          background-color: #ffffff;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .hero-learn-more-btn .arrow-badge svg {
          display: block;
        }

        .god-highlight {
          display: inline-block;
          background: linear-gradient(90deg, rgba(1,139,185,1) 0%, rgba(52,73,154,1) 100%);
          color: #ffffff;
          border-radius: 16px;
          padding: 2px 12px;
          line-height: inherit;
          font-weight: 700;
        }

        /* Estilo responsivo personalizado para los márgenes de PC */
        @media (min-width: 1024px) {
          .desktop-constrained-text {
            margin: 0px 270.797px !important;
          }
        }

        @media (max-width: 767px) {
          .acad-home-hero {
            height: 650px !important;
            min-height: 650px !important;
          }
        }
      `}</style>

      <div ref={ref} className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{
      paddingLeft: "20px",
      paddingRight: "20px",
      color: "#21211f",
      fontFamily: "'Switzer', sans-serif",
      textAlign: "center",
      maxWidth: "1200px",
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto"
    }}>
        <h2 className="desktop-constrained-text" style={{
        color: "#21211f",
        fontFamily: "'Switzer', sans-serif",
        fontSize: "clamp(14px, 2vw, 20px)",
        fontWeight: "600",
        lineHeight: "1.3",
        textAlign: "center",
        textTransform: "uppercase",
        marginBottom: "16px"
      }}>
          Comprometidos con la Biblia, Empoderados por el Espíritu, Participantes en Misiones
        </h2>

        <h1 style={{
        color: "#21211f",
        fontFamily: "'Switzer', sans-serif",
        fontSize: "clamp(36px, 7vw, 80px)",
        fontWeight: "400",
        lineHeight: "1.1",
        margin: "24px 0px",
        textAlign: "center",
        textTransform: "uppercase"
      }}>
          Bienvenidos a las
          <br />
          Asambleas de{" "}
          <span className="god-highlight">DIOS</span>
        </h1>

        <p className="desktop-constrained-text" style={{
        color: "#21211f",
        fontFamily: "'Switzer', sans-serif",
        fontSize: "clamp(15px, 2vw, 20px)",
        fontWeight: "600",
        lineHeight: "1.3",
        textAlign: "center",
        textTransform: "uppercase",
        marginTop: "0px",
        marginBottom: "36px"
      }}>
          Únase a nuestra misión de ver una iglesia saludable y empoderada por el Espíritu en cada comunidad
        </p>

        <div style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "24px"
      }}>
          <Link to="#estadisticas" className="hero-learn-more-btn" style={{
          backgroundImage: "linear-gradient(90deg, rgba(1,139,185,1) 0%, rgba(52,73,154,1) 100%)"
        }}>
            Más Información
            <span className="arrow-badge">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.5 9.5L9.5 2.5M9.5 2.5H4M9.5 2.5V8" stroke="#21211F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        </div>
      </div>
    </section>;
}
